import React, { useState, useEffect } from 'react'
import { Row, Col, Panel } from 'rsuite'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import moment from 'moment'
import SearchWidget from '../../widgets/dashboard/SearchWidget'
import UpStreamWidget from '../../widgets/dashboard/UpStreamWidget'
import DownStreamWidget from '../../widgets/dashboard/DownStreamWidget'
import UpDownStreamTableWidget from '../../widgets/dashboard/UpDownStreamTableWidget'
import ChartBudgetPalnApproved from '../../widgets/dashboard/ChartBudgetPalnApproved'
import ChartOperationArea from '../../widgets/dashboard/ChartOperationArea'
import Chart10Issue from '../../widgets/dashboard/Chart10Issue'
import ChartBudgetApproved5Year from '../../widgets/dashboard/ChartBudgetApproved5Year'
import ChartWithdrawApproved from '../../widgets/dashboard/ChartWithdrawApproved'
import ChartBudgetApproved from '../../widgets/dashboard/ChartBudgetApproved'
import ChartProjectBudget from '../../widgets/dashboard/ChartProjectBudget'
import TotalWidget from '../../widgets/dashboard/TotalWidget'
import TotalWidget2 from '../../widgets/dashboard/TotalWidget2'
import CalendarWidget from '../../widgets/dashboard/CalendarWidget'

export default function DashboardNew() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  const userType = location.search.substring(1)

  console.log('userType : ', userType)

  useEffect(() => {
    sessionStorage.clear()
  }, [])

  // if (error) {
  //   return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  // }

  // if (!schema || isLoading) {
  //   return <PanalLoadingTemplate />
  // }

  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <Row style={{ marginBottom: 40, marginTop: 40 }}>
        <>
          <SearchWidget userType={userType} />

          <Panel
            header={' '}
            bordered
            shaded
            collapsible
            defaultExpanded
            style={{ marginTop: 20, marginBottom: 10 }}
          >
            <Row>
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {schemaMain.dataDate}
              </Col>
            </Row>

            {userType == 'coodinator' && (
              <>
                <Row>
                  <Col lg={16} md={16} sm={14} xs={24}>
                    <UpDownStreamTableWidget userType={userType} />
                  </Col>
                  <Col lg={8} md={8} sm={10} xs={24}>
                    <TotalWidget2 userType={userType} />
                  </Col>

                  <Col lg={24} md={24} sm={24} xs={24}>
                    <UpStreamWidget userType={userType} />
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <DownStreamWidget userType={userType} />
                  </Col>
                </Row>
              </>
            )}

            {userType == 'coodinator2' && (
              <>
                <Row>
                  <Col lg={16} md={16} sm={14} xs={24}>
                    <UpDownStreamTableWidget userType={userType} />
                  </Col>
                  <Col lg={8} md={8} sm={10} xs={24}>
                    <TotalWidget2 userType={userType} />
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <UpStreamWidget userType={userType} type={2} />
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <DownStreamWidget userType={userType} type={2} />
                  </Col>
                  {/* <Col lg={8} md={8} sm={12} xs={24}>
                    <UpDownStreamTableWidget userType={userType} />
                  </Col> */}
                  {/* <Col lg={12} md={12} sm={24} xs={24}>
                    <ChartBudgetPalnApproved userType={userType} />
                  </Col> */}
                </Row>
              </>
            )}

            {userType == 'manager' && (
              <>
                <Row>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <ChartOperationArea userType={userType} />
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <Chart10Issue userType={userType} />
                    <ChartBudgetApproved5Year userType={userType} />
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <ChartBudgetApproved userType={userType} />
                    <ChartWithdrawApproved userType={userType} />
                  </Col>
                </Row>
              </>
            )}

            {userType == 'user' && (
              <>
                <Row>
                  <Col lg={16} md={16} sm={24} xs={24}>
                    <UpStreamWidget userType={userType} />
                    <DownStreamWidget userType={userType} />
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <TotalWidget2 userType={userType} height="300px" />
                    <CalendarWidget />
                  </Col>
                </Row>
              </>
            )}

            {userType == 'd6' && (
              <>
                <Row>
                  <Col lg={16} md={16} sm={24} xs={24}>
                    <UpStreamWidget userType={userType} />
                    <DownStreamWidget userType={userType} />
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <ChartBudgetPalnApproved userType={userType} />
                    <ChartBudgetApproved userType={userType} />
                  </Col>
                </Row>
              </>
            )}
          </Panel>
        </>
      </Row>
    </div>
  )
}

const schemaMain = {
  header: '',
  dataDate: `ข้อมูล ณ. วันที่ ${moment().format('YYYY-MM-DD HH:mm:ss')}`,
}
